/**
 * JACO Desktop Header V2 — vanilla JS
 * Handles: drawer, promo rotation, mega-menu hover, search overlay, cart badge, sticky
 * Only runs at >=769px viewport width.
 */
(function() {
  'use strict';

  // Gate: do not run on mobile
  if (window.innerWidth < 769) return;

  // ─── DRAWER ────────────────────────────────────────────────
  var drawer = document.getElementById('jaco-v2-drawer');
  var drawerOverlay = document.getElementById('jaco-v2-drawer-overlay');
  var drawerOpen = document.getElementById('jaco-v2-hamburger');
  var drawerClose = document.getElementById('jaco-v2-drawer-close');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (drawerOverlay) drawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (drawerOverlay) drawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (drawerOpen) drawerOpen.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  // Escape key closes drawer
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeSearch();
    }
  });

  // Drawer accordion (expand sub-items)
  var expandables = document.querySelectorAll('.jaco-v2-drawer-expandable');
  expandables.forEach(function(item) {
    var link = item.querySelector('.jaco-v2-drawer-link');
    if (!link) return;
    link.addEventListener('click', function(e) {
      // Toggle sub-menu instead of navigating
      e.preventDefault();
      item.classList.toggle('expanded');
    });
  });

  // ─── PROMO BAR ROTATION ────────────────────────────────────
  (function() {
    var slides = document.querySelectorAll('#jaco-v2-promo .jaco-v2-promo-slide');
    if (slides.length <= 1) return;
    var current = 0;
    setInterval(function() {
      slides[current].classList.remove('jaco-v2-promo-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('jaco-v2-promo-active');
    }, 4000);
  })();

  // ─── MEGA-MENU HOVER ──────────────────────────────────────
  var navItems = document.querySelectorAll('.jaco-v2-has-mega');
  var hoverDelay = 150;

  navItems.forEach(function(item) {
    var openTimer = null;
    var closeTimer = null;
    var menu = item.querySelector('.jaco-v2-megamenu');

    item.addEventListener('mouseenter', function() {
      clearTimeout(closeTimer);
      openTimer = setTimeout(function() {
        // Close all other megas
        navItems.forEach(function(other) {
          if (other !== item) other.classList.remove('jaco-v2-mega-open');
        });
        item.classList.add('jaco-v2-mega-open');
      }, hoverDelay);
    });

    item.addEventListener('mouseleave', function() {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function() {
        item.classList.remove('jaco-v2-mega-open');
      }, hoverDelay);
    });

    // Keyboard: focus triggers open
    var navLink = item.querySelector('.jaco-v2-nav-link');
    if (navLink) {
      navLink.addEventListener('focus', function() {
        navItems.forEach(function(other) {
          other.classList.remove('jaco-v2-mega-open');
        });
        item.classList.add('jaco-v2-mega-open');
      });
    }
  });

  // Close mega-menus on click outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.jaco-v2-has-mega')) {
      navItems.forEach(function(item) {
        item.classList.remove('jaco-v2-mega-open');
      });
    }
  });

  // ─── SEARCH OVERLAY ───────────────────────────────────────
  var searchToggle = document.getElementById('jaco-v2-search-toggle');
  var searchOverlay = document.getElementById('jaco-v2-search-overlay');
  var searchClose = document.getElementById('jaco-v2-search-close');
  var searchInput = searchOverlay ? searchOverlay.querySelector('.jaco-v2-search-input') : null;
  var searchResults = document.getElementById('jaco-v2-search-results');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('open');
    if (searchInput) {
      setTimeout(function() { searchInput.focus(); }, 100);
    }
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('open');
    if (searchResults) {
      searchResults.innerHTML = '';
      searchResults.classList.remove('active');
    }
    if (searchInput) searchInput.value = '';
  }

  if (searchToggle) searchToggle.addEventListener('click', function(e) {
    e.stopPropagation();
    openSearch();
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  // Close search on click outside the search overlay inner
  document.addEventListener('click', function(e) {
    if (searchOverlay && searchOverlay.classList.contains('open')) {
      if (!e.target.closest('.jaco-v2-search-overlay-inner') && !e.target.closest('#jaco-v2-search-toggle')) {
        closeSearch();
      }
    }
  });

  // Predictive search in overlay
  if (searchInput && searchResults) {
    var debounceTimer = null;

    // Destroy old jQuery UI autocomplete if present on this input
    if (window.jQuery && jQuery.fn.autocomplete) {
      try { jQuery(searchInput).autocomplete('destroy'); } catch(e) {}
    }

    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var query = this.value.trim();

      if (query.length < 2) {
        searchResults.innerHTML = '';
        searchResults.classList.remove('active');
        return;
      }

      debounceTimer = setTimeout(function() {
        searchResults.innerHTML = '<div class="jaco-v2-search-loading">Searching...</div>';
        searchResults.classList.add('active');

        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=query,product&resources[limit]=10')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];

            queries = queries.filter(function(q) {
              var t = q.text.trim().toLowerCase();
              var input = searchInput.value.trim().toLowerCase();
              if (t.indexOf(' ') === -1) return false;
              if (t === input) return false;
              return true;
            }).slice(0, 3);

            if (queries.length === 0 && products.length === 0) {
              searchResults.innerHTML = '<div class="jaco-v2-search-loading">No results found</div>';
              return;
            }

            var html = '';

            if (queries.length > 0) {
              html += '<div class="jaco-v2-search-heading">Suggestions</div>';
              queries.forEach(function(q) {
                var safeText = q.text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
                var re = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
                var styledText = safeText.replace(re, '<span class="jaco-v2-search-match">$1</span>');
                html += '<a class="jaco-v2-search-suggestion" href="/search?q=' + encodeURIComponent(q.text) + '">';
                html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
                html += '<span>' + styledText + '</span></a>';
              });
            }

            if (products.length > 0) {
              html += '<div class="jaco-v2-search-heading">Products</div>';
              products.forEach(function(product) {
                var imgSrc = product.image || (product.featured_image && product.featured_image.url) || '';
                var price = '';
                if (product.price) {
                  var comparePrice = product.compare_at_price_max || product.compare_at_price;
                  var currentPrice = parseFloat(product.price).toFixed(2);
                  if (comparePrice && parseFloat(comparePrice) > parseFloat(product.price)) {
                    price = '<span class="jaco-v2-price-sale">$' + currentPrice + '</span> <span class="jaco-v2-price-compare">$' + parseFloat(comparePrice).toFixed(2) + '</span>';
                  } else {
                    price = '$' + currentPrice;
                  }
                }
                html += '<a class="jaco-v2-search-product" href="' + product.url + '">';
                if (imgSrc) html += '<img src="' + imgSrc + '" alt="" loading="lazy" />';
                html += '<div class="jaco-v2-search-product-info">';
                html += '<div class="jaco-v2-search-product-title">' + product.title + '</div>';
                if (price) html += '<div class="jaco-v2-search-product-price">' + price + '</div>';
                html += '</div></a>';
              });
            }

            searchResults.innerHTML = html;
          })
          .catch(function() {
            searchResults.innerHTML = '<div class="jaco-v2-search-loading">Search unavailable</div>';
          });
      }, 300);
    });
  }

  // ─── CART BADGE ────────────────────────────────────────────
  function updateV2CartBadge() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badge = document.getElementById('jaco-v2-cart-count');
        if (!badge) return;
        if (cart.item_count > 0) {
          badge.textContent = cart.item_count;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      })
      .catch(function() {});
  }

  // Hook into existing fetch/XHR intercepts (mobile header already patches these)
  // Just listen for cart events
  document.addEventListener('cart:updated', updateV2CartBadge);
  document.addEventListener('ajaxCart.afterCartLoad', updateV2CartBadge);

  // Also patch fetch for V2 badge (the mobile patch only updates the mobile badge)
  var origFetchV2 = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1)) {
      return origFetchV2.apply(this, arguments).then(function(response) {
        setTimeout(updateV2CartBadge, 300);
        return response;
      });
    }
    return origFetchV2.apply(this, arguments);
  };

  // ─── ZIPIFY CART HOOK (zipify_cart_hook_v2) ────────────────
  // Zipify manages the slide cart and emits its own events/methods when cart
  // changes happen via its UI (like remove buttons inside the slide cart).
  // We patch Zipify.Cart.instance.updateBubble to also trigger our V2 badge update.
  // This catches removes, quantity changes, and anything else routed through Zipify.
  function hookZipifyCart() {
    try {
      if (!window.Zipify || !window.Zipify.Cart || !window.Zipify.Cart.instance) return false;
      var inst = window.Zipify.Cart.instance;
      if (inst._jacoV2HookInstalled) return true;
      var origUpdateBubble = inst.updateBubble.bind(inst);
      inst.updateBubble = async function() {
        var result = await origUpdateBubble();
        updateV2CartBadge();
        return result;
      };
      // Also hook updateCart which fires on Zipify's internal cart state changes
      if (typeof inst.updateCart === 'function') {
        var origUpdateCart = inst.updateCart.bind(inst);
        inst.updateCart = async function() {
          var result = await origUpdateCart.apply(this, arguments);
          updateV2CartBadge();
          return result;
        };
      }
      inst._jacoV2HookInstalled = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  // Try hooking immediately, then retry if Zipify loads after us
  if (!hookZipifyCart()) {
    // Retry up to 20 times over 10 seconds
    var retries = 0;
    var retryInterval = setInterval(function() {
      retries++;
      if (hookZipifyCart() || retries >= 20) {
        clearInterval(retryInterval);
      }
    }, 500);
  }

  // Also listen for Zipify's own event layer (ocu:cart:* are fired by the OCU extension)
  document.addEventListener('ocu:cart:loaded', updateV2CartBadge);
  document.addEventListener('ocu:cart:updated', updateV2CartBadge);

  // Final safety net: poll cart every time the tab regains focus (in case user
  // modifies cart in another tab)
  window.addEventListener('focus', updateV2CartBadge);

  // ─── STICKY BEHAVIOR (JS-driven fixed) ─────────────────────
  // position:sticky fails in this theme due to overflow ancestors and
  // Shopify section wrappers. Use JS class toggle (relative ↔ fixed)
  // with a spacer div to prevent layout shift — same pattern as mobile header.
  var wrapper = document.getElementById('jaco-v2-wrapper');
  var headerEl = document.getElementById('jaco-v2-header');
  if (wrapper) {
    // Use server-rendered spacer if present (prevents FOUC layout shift on load).
    // Fallback: create one if missing.
    var spacer = document.querySelector('.jaco-v2-spacer');
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'jaco-v2-spacer';
      wrapper.parentNode.insertBefore(spacer, wrapper.nextSibling);
    }

    var wrapperTop = wrapper.offsetTop;
    var ticking = false;

    function updateSticky() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollY >= wrapperTop) {
        if (!wrapper.classList.contains('jaco-v2-wrapper-fixed')) {
          var h = wrapper.offsetHeight;
          spacer.style.height = h + 'px';
          spacer.classList.add('active');
          wrapper.classList.add('jaco-v2-wrapper-fixed');
        }
      } else {
        if (wrapper.classList.contains('jaco-v2-wrapper-fixed')) {
          wrapper.classList.remove('jaco-v2-wrapper-fixed');
          spacer.classList.remove('active');
          spacer.style.height = '0';
        }
      }
      // Scroll-shrink effect on header bar
      if (headerEl) {
        if (scrollY > 100) {
          headerEl.classList.add('jaco-v2-scrolled');
        } else {
          headerEl.classList.remove('jaco-v2-scrolled');
        }
      }
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function() {
          updateSticky();
          ticking = false;
        });
      }
    }, { passive: true });

    // Recalculate offset on resize (e.g., promo bar height changes)
    window.addEventListener('resize', function() {
      if (!wrapper.classList.contains('jaco-v2-wrapper-fixed')) {
        wrapperTop = wrapper.offsetTop;
      }
    }, { passive: true });

    // Initial check (page may load scrolled)
    updateSticky();
  }



  // ─── DRAWER PREDICTIVE SEARCH (iter 15) ─────────────────────
  // Mirrors mobile predictive search logic for the V2 drawer search input.
  var drawerSearchInput = document.querySelector('#jaco-v2-drawer-search input[type="search"]');
  var drawerResultsContainer = document.getElementById('jaco-v2-predictive-results');
  if (drawerSearchInput && drawerResultsContainer) {
    var dsDebounce = null;
    drawerSearchInput.addEventListener('input', function() {
      var query = drawerSearchInput.value.trim();
      clearTimeout(dsDebounce);
      if (query.length < 2) {
        drawerResultsContainer.innerHTML = '';
        drawerResultsContainer.classList.remove('has-results');
        return;
      }
      dsDebounce = setTimeout(function() {
        drawerResultsContainer.innerHTML = '<div class="jaco-predictive-loading">Searching...</div>';
        drawerResultsContainer.classList.add('has-results');
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=query,product&resources[limit]=10')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var suggestions = (data.resources && data.resources.results && data.resources.results.queries) || [];
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (suggestions.length === 0 && products.length === 0) {
              drawerResultsContainer.innerHTML = '<div class="jaco-predictive-loading">No results found</div>';
              return;
            }
            var html = '';
            var safeQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            var re = new RegExp('(' + safeQuery + ')', 'ig');
            if (suggestions.length > 0) {
              html += '<div class="jaco-predictive-section-heading">Suggestions</div>';
              suggestions.slice(0, 5).forEach(function(q) {
                var safeText = (q.text || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                var styledText = safeText.replace(re, '<span class="jaco-predictive-match">$1</span>');
                html += '<a class="jaco-predictive-suggestion" href="' + q.url + '">';
                html += '<svg class="jaco-predictive-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
                html += '<span>' + styledText + '</span>';
                html += '</a>';
              });
            }
            if (products.length > 0) {
              html += '<div class="jaco-predictive-section-heading">Products</div>';
              products.slice(0, 6).forEach(function(product) {
                var img = product.featured_image && product.featured_image.url ? product.featured_image.url : (product.image || '');
                var price = product.price ? product.price : '';
                html += '<a class="jaco-predictive-item" href="' + product.url + '">';
                if (img) html += '<img src="' + img + '" alt="" loading="lazy" />';
                html += '<div class="jaco-predictive-info">';
                html += '<div class="jaco-predictive-title">' + (product.title || '') + '</div>';
                if (price) html += '<div class="jaco-predictive-price">' + price + '</div>';
                html += '</div>';
                html += '</a>';
              });
            }
            drawerResultsContainer.innerHTML = html;
          })
          .catch(function() {
            drawerResultsContainer.innerHTML = '<div class="jaco-predictive-loading">Search unavailable</div>';
          });
      }, 200);
    });
    // Clear results when drawer closes
    var drawerEl = document.getElementById('jaco-v2-drawer');
    if (drawerEl) {
      var observer = new MutationObserver(function(muts) {
        muts.forEach(function(m) {
          if (m.attributeName === 'class' && !drawerEl.classList.contains('open')) {
            drawerSearchInput.value = '';
            drawerResultsContainer.innerHTML = '';
            drawerResultsContainer.classList.remove('has-results');
          }
        });
      });
      observer.observe(drawerEl, { attributes: true });
    }
  }

})();
